import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Employee } from 'src/app/models/Employees';
import { RelativeService } from 'src/app/services/modelService/relative.service';
import { ToastService } from 'src/app/util/toast.service';
import { UtilityService } from 'src/app/util/utility.service';
import * as jsonData from 'src/assets/json/pincode.json';
import * as jsonData2 from 'src/assets/json/pincode2.json';



@Component({
  selector: 'app-user-merge',
  templateUrl: './user-merge.component.html',
  styleUrls: ['./user-merge.component.scss'],
})
export class UserMergeComponent implements OnInit {

  @Output() closePopup = new EventEmitter<boolean>();
  @Input() merge_editable: Employee = new Employee();
  @Input() merge_nonEditable: Employee = new Employee();
  showPincodeOption1: boolean = false;
  filteredPinCode = [];
  areaList: any = jsonData;
  districtList: any = jsonData2;

  constructor(public toastService: ToastService, public platform: Platform,
    private relativeService: RelativeService, public utilityService: UtilityService, private toast: ToastService) { }

  ngOnInit() {
    if (!this.merge_editable.id || !this.merge_nonEditable.id || !this.merge_editable.user.id || !this.merge_nonEditable.user.id) {
      this.toast.warning("These are already merged. Please refresh the page");
      this.closePopup.emit();
    } else {
      this.mergeEditableIntoNonEditable();
    }
  }

  mergeEditableIntoNonEditable() {
    this.merge_editable.user.user_pd.current_address2 = this.merge_editable.user.user_pd.current_address2 ?? this.merge_nonEditable.user.user_pd.current_address2;
    this.merge_editable.user.user_pd.death_date = this.merge_editable.user.user_pd.death_date ?? this.merge_nonEditable.user.user_pd.death_date;
    this.merge_editable.user.user_pd.email = this.merge_editable.user.user_pd.email ?? this.merge_nonEditable.user.user_pd.email;
    this.merge_editable.user.user_pd.marital = this.merge_editable.user.user_pd.marital ?? this.merge_nonEditable.user.user_pd.marital;
    this.merge_editable.user.user_pd.mobile = this.merge_editable.user.user_pd.mobile ?? this.merge_nonEditable.user.user_pd.mobile;
    this.merge_editable.user.user_pd.pincode = this.merge_editable.user.user_pd.pincode ?? this.merge_nonEditable.user.user_pd.pincode;
    this.merge_editable.user.user_pd.state = this.merge_editable.user.user_pd.state ?? this.merge_nonEditable.user.user_pd.state;
    this.merge_editable.user.user_pd.country = this.merge_editable.user.user_pd.country ?? this.merge_nonEditable.user.user_pd.country;
    this.merge_editable.user.user_pd.district = this.merge_editable.user.user_pd.district ?? this.merge_nonEditable.user.user_pd.district;
    this.merge_editable.user.user_pd.area = this.merge_editable.user.user_pd.area ?? this.merge_nonEditable.user.user_pd.area;
    this.merge_editable.user.user_pd.origin_city = this.merge_editable.user.user_pd.origin_city ?? this.merge_nonEditable.user.user_pd.origin_city;
    this.merge_editable.user.user_pd.profession = this.merge_editable.user.user_pd.profession ?? this.merge_nonEditable.user.user_pd.profession;
    this.merge_editable.user.user_pd.education = this.merge_editable.user.user_pd.education ?? this.merge_nonEditable.user.user_pd.education;
    this.merge_editable.user.user_pd.occupation = this.merge_editable.user.user_pd.occupation ?? this.merge_nonEditable.user.user_pd.occupation;
    this.merge_editable.user.user_pd.sub_community = this.merge_editable.user.user_pd.sub_community ?? this.merge_nonEditable.user.user_pd.sub_community;
    this.merge_editable.user.user_pd.blood = this.merge_editable.user.user_pd.blood ?? this.merge_nonEditable.user.user_pd.blood;
    if (this.merge_editable.user.user_pd.status == 'Verified' || this.merge_nonEditable.user.user_pd.status == 'Verified') {
      this.merge_editable.user.user_pd.status = 'Verified';
    } else {
      this.merge_editable.user.user_pd.status = this.merge_editable.user.user_pd.status ?? this.merge_nonEditable.user.user_pd.status;
    }
    this.merge_editable.user.dob = this.merge_editable.user.dob ?? this.merge_nonEditable.user.dob;
    this.merge_editable.user.gender = this.merge_editable.user.gender ?? this.merge_nonEditable.user.gender;
    this.merge_editable.user.name = this.merge_editable.user.name ?? this.merge_nonEditable.user.name;
    this.merge_editable.user.name = this.merge_editable.user.name ?? this.merge_nonEditable.user.name;
    this.merge_editable.user.last_name = this.merge_editable.user.last_name ?? this.merge_nonEditable.user.last_name;

  }

  searchPincode(search) {
    if (search.length > 3) {
      this.showPincodeOption1 = true;
      this.filteredPinCode = this.areaList.area.filter(x => x.toLowerCase().indexOf(search.toLowerCase()) > -1);
    } else {
      this.showPincodeOption1 = false;
    }
  }

  setAddress(pin: string, type: string) {
    this.merge_editable.user.user_pd.pincode = pin.split(':')[0];
    this.merge_editable.user.user_pd.area = pin.split(':')[1].split(",")[0];
    this.merge_editable.user.user_pd.town = pin.split(':')[1].split(",")[1];
    for (let key in this.districtList) {
      if (this.districtList[key] && (this.districtList[key] + "").split(", ")[1] == this.merge_editable.user.user_pd.pincode.substring(0, 3)) {
        console.log(this.districtList[key], key);
        this.merge_editable.user.user_pd.state = (this.districtList[key] + "").split(", ")[0];
        this.merge_editable.user.user_pd.district = key;
      }
    }
    if (this.merge_editable.user.user_pd.town) {
      this.merge_editable.user.user_pd[type + 2] = this.merge_editable.user.user_pd.area + ", " + this.merge_editable.user.user_pd.town + ", " + this.merge_editable.user.user_pd.district + ", " + this.merge_editable.user.user_pd.state + ", " + this.merge_editable.user.user_pd.pincode;
    } else {
      this.merge_editable.user.user_pd[type + 2] = this.merge_editable.user.user_pd.area + ", " + this.merge_editable.user.user_pd.district + ", " + this.merge_editable.user.user_pd.state + ", " + this.merge_editable.user.user_pd.pincode;
      this.merge_editable.user.user_pd.town = this.merge_editable.user.user_pd.district;
    }

    this.merge_editable.user.user_pd.country = "India";
    console.log(this.merge_editable.user.user_pd[type + 2]);
    this.showPincodeOption1 = false;
  }

  async clickMerge() {
    await this.relativeService.finalMerge(this.merge_nonEditable, this.merge_editable);
    this.closePopup.emit();
  }


}
